<div class="alter-box" *ngIf="message">
  <div class="message-box" [ngClass]="{ success: message.type === 'success', error: message.type === 'error' }">
    <i class="pi {{ message.type === 'success' ? 'pi-check' : 'pi-exclamation-triangle' }}"></i>
    <p class="ml-2 text-white">{{ message.message }}</p>
  </div>
</div>

<div class="mfa-box" *ngIf="mfa_error">
  <div class="mfa-error">
    <i class="pi pi-exclamation-triangle f-24"></i>
    <div class="ml-3 w-100">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <p class="text-danger _fw-600">No MFA Assigned</p>
          <p class="text-danger">To enhance security, you must assign Multi-Factor Authentication (MFA) to your account.</p>
          <p class="text-danger">
            You have <b>{{ mfa_day }} days</b> to complete this before your account is deactivated.
          </p>
        </div>
        <button class="mfabutton ml-5" (click)="enableMFA()">Assign MFA</button>
      </div>
    </div>
  </div>
</div>
